import { render } from "./BaseActionTitle.vue?vue&type=template&id=fbbf75a2"
import script from "./BaseActionTitle.vue?vue&type=script&lang=js"
export * from "./BaseActionTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fbbf75a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbbf75a2', script)) {
    api.reload('fbbf75a2', script)
  }
  
  module.hot.accept("./BaseActionTitle.vue?vue&type=template&id=fbbf75a2", () => {
    api.rerender('fbbf75a2', render)
  })

}

script.__file = "src/ui/BaseActionTitle.vue"

export default script